import { useContext } from 'react';
import { CitrusUser } from '../context/CitrusUser';
/**
 * Hook to consume the entire CitrusUser context
 *
 * @returns {CitrusUserType}
 * @example
 * import { useLocalization } from '@citrus/user';
 * ...
 * const settings = useCitrusUser();
 */
export var useCitrusUser = function () { return useContext(CitrusUser); };
